import React from 'react';
import classnames from 'classnames';
import Text from 'components/components/Text';
import RenderIf from 'components/components/RenderIf';
import identity from 'utils/identity';
import './RequestRow.scss';

type Props = {
  requestId: number, requestTitle: string, requestStatus: string,
  rowDataLeft?: string, rowDataRight: string, date: string,
  statusClassName?: string, highlight?: boolean, unsent?: boolean,
  logos?: { key: string, src?: string }[], largeLogos?: boolean,
  statusAction?: React.ReactNode, actions: React.ReactNode,
};

const RequestRowContent = ({
  requestId, requestTitle, requestStatus, rowDataLeft, rowDataRight, date,
  statusClassName, highlight, unsent, logos, largeLogos, statusAction, actions,
}: Props) => (
  <div className={classnames('request-row', { 'highlighted-row': highlight })}>
    <div className="request-row__info-container">
      <div className="request-row__info-container--left">
        {logos?.map(({ key, src }) => (
          <span key={key} className={classnames('request-row__info-container__logo', { lg: largeLogos })}>
            {src?.trim() && (
              <img
                key={src}
                src={src}
                alt=""
                onError={(event) => { event.currentTarget.style.visibility = 'hidden'; }}
              />
            )}
          </span>
        ))}
      </div>
      <div className="request-row__info-container--right">
        <div className="request-row__status-container">
          <p className={classnames('request-row__status', statusClassName)}>
            {requestStatus}
          </p>
          {statusAction}
        </div>
        <div className="request-row__request-info">
          <Text text={requestTitle} size="xs" />
          <div className={classnames('request-row__request-info--row', { unsent })}>
            <RenderIf condition={identity.isTruthyString(rowDataLeft)}>
              <span className="request-row__request-info--row__details">{rowDataLeft}</span>
              <div className="dot" />
            </RenderIf>
            <span className="request-row__request-info--row__details">{rowDataRight}</span>
          </div>
          <div className="request-row__request-info--row">
            <span className="request-row__request-info--row__details">{`R#${requestId}`}</span>
            <div className="dot" />
            <span className="request-row__request-info--row__details">{date}</span>
          </div>
        </div>
      </div>
    </div>
    {actions}
  </div>
);

RequestRowContent.defaultProps = {
  rowDataLeft: '',
  statusClassName: '',
  highlight: false,
  unsent: false,
  logos: undefined,
  statusAction: undefined,
  largeLogos: true,
};

export default RequestRowContent;
